import React, { Component } from 'react';
import { Button, Input, Icon, Statistic, Table, message } from 'antd';
import axios from "axios";
import { proveedorDetailURL, pedidoNuevoURL } from '../../constants';
import { connect } from 'react-redux';
import * as actionsProveedor from "./../../store/actions/proveedores";

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
    },
    {
        title: 'Marca',
        dataIndex: 'marca',
        key: 'marca',
    },
    {
        title: 'Cantidad',
        dataIndex: 'cantidad',
        key: 'cantidad',
    },
    {
        title: 'Costo',
        dataIndex: 'costo',
        key: 'costo',
    },
];

export class Confirm extends Component {

    state = {
        nombreProv: ''
    }
    componentDidMount() {
        const { proveedor } = this.props
        if (proveedor !== undefined) {
            //SI SE PUEDE: .get(proveedorDetailURL + proveedor + '/') 
            //NO SE PUEDE: .get(proveedorDetailURL, proveedor) Es una función, get no acepta parametros(creo) y por eso me daba errores
            axios
                .get(proveedorDetailURL(proveedor)) // MANERA OPTIMA Y CORRECTA
                .then(res => {
                    console.log(res.data.nombre)
                    this.setState({
                        nombreProv: res.data.nombre
                    });
                })
                .catch(err => {
                    console.log(err)
                });
        }
    }

    back = e => {
        e.preventDefault();
        this.props.prevStep();
    };

    handleChange = (e) => {
        this.props.onHandleChangedComentarios(e.target.value)
    };

    handleSubmit = () => {
        const { productosPedido, proveedor, comentarios, history } = this.props
        axios
            .post(pedidoNuevoURL, {
                productosPedido,
                proveedor,
                comentarios
            })
            .then(res => {
                history.replace(`/pedidos/`);
                this.props.onSubmitResetReduxState()
                message.success('El pedido fue registrado con éxito.');
            })
            .catch(err => {
                console.log(err)
                message.error(err.response.data.message);
            });
    }

    render() {
        const { productosPedido, comentarios, valorTotal } = this.props;
        const { nombreProv } = this.state

        let counter = 0
        let productosB = productosPedido.map(prod => {
            counter += 65;
            return (
                {
                    key: prod.id + counter, //unique key
                    id: prod.id,
                    marca: prod.marca.nombre,
                    nombre: prod.nombre,
                    cantidad: prod.cantidad,
                    costo: prod.costo,
                }
            )
        });
        return (
            <React.Fragment>
                <div style={{ textAlign: 'center' }}>
                    <Table locale={{ emptyText: 'No hay productos seleccionados' }} size={'small'} columns={columns} dataSource={productosB} bordered={true} pagination={false} />
                    <br></br>
                    <h3>Proveedor: {nombreProv}</h3>
                    <Input.TextArea placeholder="Notas / Comentarios" onChange={(e) => this.handleChange(e)} maxLength={300} style={{ height: 50, maxWidth: '450px' }} value={comentarios} />
                    <br></br>
                    <br></br>
                    <Statistic title="Total" prefix={"MX"} value={valorTotal} precision={2} />
                    <br></br>
                    <Button.Group>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={this.back}>
                            <Icon type="left" /> Regresar
                        </Button>

                        <Button
                            type="primary"
                            variant="contained"
                            onClick={this.handleSubmit}>
                            Confirmar Pedido <Icon type="save" />
                        </Button>
                    </Button.Group>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        proveedor: state.proveedor.proveedor,
        comentarios: state.proveedor.comentarios,
        productosPedido: state.producto.productosPedido,
        valorTotal: state.producto.valorTotal,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onHandleChangedComentarios: (val) => dispatch(actionsProveedor.handleChangedComentarios(val)),
        onSubmitResetReduxState: () => dispatch({ type: 'RESET_REDUX_STATE' })
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Confirm);